/**
 * author zhang.yingyu
 * createTime 2019-05-08
 * */
"use strict";
angular.module('appPreviewPublishModule', []).
controller('appPreviewPublishCtrl', appPreviewPublishCtrl);
appPreviewPublishCtrl.inject = ["$scope", "$timeout", "$modalInstance", "trsHttpService", "trsspliceString", "modalDialog","previewUrl"];

function appPreviewPublishCtrl($scope, $timeout, $modalInstance, trsHttpService, trsspliceString, modalDialog,previewUrl) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     */
    function initStatus() {
        $scope.status={
            previewUrl:previewUrl,
        };
    }

    /**
     * [initData description] 初始化数据
     */
    function initData(){
      $timeout(function(){
          var content=document.getElementById('preview').contentWindow.document;
          $(content).find("html").css("overflow-x","hidden");
          $(content).find("html img").css("max-width","100%");
      },500);
    };
    /**
     * [close description] 关闭
     */
    $scope.close = function() {
        $modalInstance.dismiss();
    };
}